module.exports = __webpack_public_path__ + "img/radiografia1.a209f2a6.jpg";